import React, { Component } from "react";
import axios from "axios";
import Helping from "../../helpers/Helping";
import Service from "../../helpers/service";
import { Link, useHistory } from "react-router-dom";
import Notification from "../layout/Notification";
import Pagination from "react-js-pagination";
import MoneyField from '../fields/moneyField';
import route from '../../config/routes';
import { addCurrentRoute } from '../../actions/profile_action';
import { getAll, destroy } from '../../services/transaction.service';
import { connect } from 'react-redux';
import { MESSAGE, TRANSACTION } from '../../config/index';
import { getAll as getCopies, destroy as destroyCopies } from '../../services/item_copies.service';
import { trackPromise } from "react-promise-tracker";
import {
    API_URL,
    META_MASK,
    MATIC_META_MASK,
    TEZOS_META_MASK,
    STORE_WEBSITE
} from '../../config/urls';
import $ from 'jquery';

const { NOT_FOUND } = MESSAGE;
class Detail extends Component {
    constructor(props) {
        super(props);

        this.state = {
            url: '',
            user: {},
            rows: [],
            pageTitle: 'User Detail',
            routeName: '/user',
            error_message: '',
            error_type: '',
            isLoading: true,
            btnIsEnable: false,
            total: 0,
            activePage: 1,
            wallet_activePage: 1,
            item_activePage: 1,
            limit: TRANSACTION.LIMIT,
            wallet_limit: 10,
            item_limit: 10,
            wallet_no_Of_pages: 1,
            item_no_Of_pages: 1,
            search: '',
            status: '',
            blockchain: '',
            buyerName: '',
            startDate: '',
            endDate: '',
            payment_type: '',
            type: '',
            sorting: 'id',
            sort_type: 'DESC',
            transactionCollapse: false,
            id: ''
        };
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleLimitChange = this.handleLimitChange.bind(this);
        this.handleWalletPageChange = this.handleWalletPageChange.bind(this);
        this.handleWalletLimitChange = this.handleWalletLimitChange.bind(this);
        this.handleInventoryPageChange = this.handleInventoryPageChange.bind(this);
        this.handleInventoryLimitChange = this.handleInventoryLimitChange.bind(this);
    }

    scrollToTop = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }

    componentDidMount() {
        var self = this;
        if (this.props.match.params.id) {

            self.setState({
                url: API_URL.ADMIN_API + route.GET_USER
            }, function () {
                self.getById();
                this.props.addCurrentRoute(this.props.profile, this.props.location.pathname);
            });
        }
    }

    removeNetworkError = () => {
        this.setState({ ...Helping.clearNetworkRequest() });
    }

    handlePageChange(pageNumber) {
        if (this.state.activePage === pageNumber) {
            return false;
        }

        this.setState({
            activePage: pageNumber
        }, () => {
            this.getTransactions();
        });
    }

    handleLimitChange(itemsLimit) {
        if (this.state.limit === itemsLimit) {
            return false;
        }
        this.setState({
            limit: itemsLimit,
            activePage: 1
        }, () => {
            this.getTransactions();
        });
    }

    handleWalletPageChange(pageNumber) {
        if (this.state.wallet_activePage === pageNumber) {
            return false;
        }

        this.setState({
            wallet_activePage: pageNumber
        }, () => {
            this.getWalletHistory();
        });
    }

    handleWalletLimitChange(itemsLimit) {
        if (this.state.wallet_limit === itemsLimit) {
            return false;
        }
        this.setState({
            wallet_limit: itemsLimit,
            wallet_activePage: 1
        }, () => {
            this.getWalletHistory();
        });
    }

    handleInventoryPageChange(pageNumber) {
        if (this.state.item_activePage === pageNumber) {
            return false;
        }

        this.setState({
            item_activePage: pageNumber
        }, () => {
            this.getItems();
        });
    }

    handleInventoryLimitChange(itemsLimit) {
        if (this.state.item_limit === itemsLimit) {
            return false;
        }
        this.setState({
            item_limit: itemsLimit,
            item_activePage: 1
        }, () => {
            this.getItems();
        });
    }

    getById = () => {
        let self = this;

        trackPromise(
            Service.getCall(this.state.url + this.props.match.params.id)
                .then((response) => {
                    var { user } = response.data.payload;

                    self.setState({
                        user: user,
                        isLoading: false,
                        buyerName: user.username,
                        id: user.id
                    });
                })
                .catch((error) => {
                    if (error.response) {
                        Helping.redirectToLogin(error);
                        return self.setState(
                            {
                                error_message: error.response.data.message,
                                error_type: 'danger',
                                isLoading: false,
                            },
                            () => this.scrollToTop()
                        );
                    }
                    return this.setState(
                        {
                            isLoading: false,
                            ...Helping.setNetworkRequestError(error, 'fetching user'),
                        },
                        () => this.scrollToTop()
                    );
                })
        )
    }

    openTransactionCard = (e) => {
        if (!$(e.target).hasClass("collapsed")) {
            this.getTransactions();
        }
    }

    openWalletCard = (e) => {
        if (!$(e.target).hasClass("collapsed") && this.state.rows.length < 1) {
            this.getWalletHistory();
        }
    }

    openInventoryCard = (e) => {
        if (!$(e.target).hasClass("collapsed")) {
            this.getItems();
        }
    }

    getItems = () => {
        this.props.getCopies(
            this.state.item_activePage,
            this.state.item_limit,
            "",
            this.state.sorting,
            this.state.sort_type,
            "", "", "", "", "", "",
            this.state.id);
    }

    getTransactions = () => {
        this.props.getAll(this.state.activePage, this.state.limit, this.state.sorting, this.state.sort_type, this.state.buyerName, this.state.payment_type, this.state.status, this.state.type, this.state.blockchain, this.state.startDate, this.state.endDate);
    }

    getWalletHistory = () => {
        let { buyerName, wallet_activePage, wallet_limit } = this.state
        this.setState({ isLoading: true })
        let self = this,
            body = {
                action: "wallet-history",
                search: buyerName.trim(),
                page: wallet_activePage,
                limit: wallet_limit
            }

        trackPromise(
            axios.post(API_URL.ADMIN_TRADING_API + route.REPORTS, body, Helping.getConfig()).then(response => {
                let payload = response.data.payload;

                self.setState({
                    rows: payload.rows,
                    total: payload.count,
                    wallet_no_Of_pages: Math.ceil(payload.count / wallet_limit),
                    isLoading: false
                })
            }).catch(error => {
                console.log(error);
                self.setState({
                    rows: [],
                    total: 0,
                    isLoading: false
                })
            })
        )

    }

    getMetaMaskLink = (copy) => {
        if (copy.which_bc === "MATIC")
            return MATIC_META_MASK.LINK + copy.id;

        else if (copy.which_bc === "ETH")
            return META_MASK.LINK + copy.id;

        else if (copy.which_bc === "TEZOS")
            return TEZOS_META_MASK.LINK + copy.id;
    }

    getOwnerName(username) {
        if (username === 'admin') {
            return 'Terra Virtua'
        }

        return username
    }

    redirectToTransactionDetailPage = (e, object) => {
        this.props.history.push(`/transaction/${object.id}`);
    }

    componentWillUnmount(){
        this.props.destroy();
        this.props.destroyCopies();
    }

    render() {
        const { user } = this.state;
        // const history = useHistory();
        return (
            <div class="content user-view">
                {user && (
                    <>
                        <div class="top-header">
                            <div class="header-title">
                                <h2 class="title">{user.firstName} {user.lastName}</h2>
                                <span class="title-caption">Customer</span>
                            </div>
                            <div class="header-btn">
                                <button class="custom-btn dark-btn icon-btn sm-btn" onClick={() => this.props.history.goBack()}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15.5" height="12.117" viewBox="0 0 15.5 12.117">
                                        <g id="Arrow_-_Left" data-name="Arrow - Left" transform="translate(0.75 1.059)">
                                            <g id="Arrow_-_Left-2" data-name="Arrow - Left" transform="translate(14) rotate(90)">
                                                <path id="Stroke_1" data-name="Stroke 1" d="M0,14V0" transform="translate(5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" />
                                                <path id="Stroke_3" data-name="Stroke 3" d="M10,0,5,5.647,0,0" transform="translate(0 8.353)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" />
                                            </g>
                                        </g>
                                    </svg>
                                    <span class="txt-btn">Back</span>
                                </button>
                            </div>
                        </div>
                        <div class="main-content  view-page-content">
                            <div class="view-tabs multiple-tabs">
                                <ul class="nav nav-tabs" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" data-toggle="tab" href="#personal" role="tab">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20">
                                                <path id="user" d="M12,2a4.985,4.985,0,1,0,5,4.984A4.993,4.993,0,0,0,12,2Zm0,1.994a2.991,2.991,0,1,1-3,2.99A3,3,0,0,1,12,3.994Zm2,8.972a5.99,5.99,0,0,1,6,5.981v2.025a1,1,0,0,1-2,0V18.947a3.994,3.994,0,0,0-4-3.987H10a3.994,3.994,0,0,0-4,3.987V21a1,1,0,0,1-2,0V18.947a5.99,5.99,0,0,1,6-5.981Z" transform="translate(-4 -2)" />
                                            </svg>
                                            <span class="tab-text">Personal</span>
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#transaction" role="tab" onClick={this.getTransactions}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20">
                                                <path id="transactions" d="M5.6,2A3.816,3.816,0,0,0,2,6V18a3.816,3.816,0,0,0,3.6,4H16.4A3.816,3.816,0,0,0,20,18V6a3.816,3.816,0,0,0-3.6-4Zm0,2H16.4a1.907,1.907,0,0,1,1.8,2V18a1.907,1.907,0,0,1-1.8,2H5.6a1.907,1.907,0,0,1-1.8-2V6A1.907,1.907,0,0,1,5.6,4Zm9.9,2a.954.954,0,0,1,.9,1,.954.954,0,0,1-.9,1h-9a.954.954,0,0,1-.9-1,.954.954,0,0,1,.9-1Zm0,5a1.006,1.006,0,0,1,0,2h-9a1.006,1.006,0,0,1,0-2Zm0,5a1.006,1.006,0,0,1,0,2h-9a1.006,1.006,0,0,1,0-2Z" transform="translate(-2 -2)" />
                                            </svg>
                                            <span class="tab-text">Transactions</span>
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#walletHistory" role="tab" onClick={this.getWalletHistory}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                                                <path id="wallet" d="M5.6,2A3.6,3.6,0,0,0,2,5.6v7.2a.9.9,0,0,0,.9.9H7.569a3.534,3.534,0,0,0,6.862.028H19.1a.9.9,0,0,0,.9-.9V5.6A3.6,3.6,0,0,0,16.4,2Zm0,1.8H16.4a1.8,1.8,0,0,1,1.8,1.8v6.328H13.7a.909.909,0,0,0-.9.9A1.8,1.8,0,0,1,9.2,12.8a.9.9,0,0,0-.9-.9H3.8V5.6A1.8,1.8,0,0,1,5.6,3.8ZM3.8,16.4a1.8,1.8,0,0,0,1.8,1.8H16.4a1.8,1.8,0,0,0,1.8-1.8.9.9,0,1,1,1.8,0A3.6,3.6,0,0,1,16.4,20H5.6A3.6,3.6,0,0,1,2,16.4a.9.9,0,1,1,1.8,0Z" transform="translate(-2 -2)" />
                                            </svg>
                                            <span class="tab-text">Wallet History</span>
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#Inventory" role="tab" onClick={this.getItems}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                                                <path id="inventory" d="M5.6,2A3.6,3.6,0,0,0,2,5.6V7.4a.9.9,0,0,0,.9.9H19.1a.9.9,0,0,0,.9-.9V5.6A3.6,3.6,0,0,0,16.4,2Zm0,1.8H16.4a1.8,1.8,0,0,1,1.8,1.8v.9H3.8V5.6A1.8,1.8,0,0,1,5.6,3.8ZM4.7,11v5.4a1.667,1.667,0,0,0,1.49,1.8H15.81a1.667,1.667,0,0,0,1.49-1.8V11a.9.9,0,1,1,1.8,0v5.4A3.449,3.449,0,0,1,15.81,20H6.19A3.449,3.449,0,0,1,2.9,16.4V11a.9.9,0,0,1,1.8,0Zm4.95,0a2.25,2.25,0,0,0,0,4.5h2.7a2.25,2.25,0,0,0,0-4.5Zm0,1.8h2.7a.45.45,0,0,1,0,.9H9.65a.45.45,0,0,1,0-.9Z" transform="translate(-2 -2)" />
                                            </svg>
                                            <span class="tab-text">Inventory</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="tab-content">
                                <div class="tab-pane active userPersonalInfo" id="personal" role="tabpanel">
                                    <div class="row align-items-center user-profile">
                                        <div class="col-md-12 col-lg-3 user-info-col">
                                            <div class="user-dp">
                                                <img src={user.default_avatar ? user.default_avatar.thumbnail_url : "/img/default_user_img.png"} alt="" class="img-fluid" />
                                            </div>
                                            <h5 class="user-name">{user.firstName} {user.lastName}</h5>
                                            <span class="user-status">Status: {user.isConfirmed ? "Verified" : "Disproved"}</span>
                                        </div>
                                        <div class="col-sm-6 col-md-6 col-lg-4">
                                            <ul class="list-view">
                                                <li>
                                                    <label for="">User ID</label>
                                                    <span>{user.id}</span>
                                                </li>
                                                <li>
                                                    <label for="">Date of Birth</label>
                                                    <span>{user.birthDate ? user.birthDate : 'Nil'}</span>
                                                </li>
                                                <li>
                                                    <label for="">Gender</label>
                                                    <span>{user.gender ? user.gender : 'Nil'}</span>
                                                </li>
                                                <li>
                                                    <label for="">Country</label>
                                                    <span>{user.country ? user.country.name : ""}</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-sm-6 col-md-6 col-lg-5">
                                            <ul class="list-view">
                                                <li>
                                                    <label for="">Username</label>
                                                    <span>{user.username}</span>
                                                </li>
                                                <li>
                                                    <label for="">Firstname</label>
                                                    <span>{user.firstName}</span>
                                                </li>
                                                <li>
                                                    <label for="">Lastname</label>
                                                    <span>{user.lastName}</span>
                                                </li>
                                                <li>
                                                    <label for="">Email</label>
                                                    <span class="user-email truncate">{user.email ? user.email : ""}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane" id="transaction" role="tabpanel">
                                    {this.props.total > 0 && (
                                        <>
                                            <div class="listing-tbl table-responsive">
                                                <table class="table">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">ID</th>
                                                            <th scope="col" class="userFullName">Buyer Name</th>
                                                            <th scope="col">Type</th>
                                                            <th scope="col">Total Amount</th>
                                                            <th scope="col">Payment Type</th>
                                                            <th scope="col">Status</th>
                                                            <th scope="col">Date Created</th>
                                                            <th scope="col"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.props.transactions.map((transaction, i) => (
                                                            <tr key={i}>
                                                                <td scope="row">{transaction.id}</td>
                                                                <td>
                                                                    <div class="user-info">
                                                                        <div class="info">
                                                                            <h5 class="name">{transaction.buyer ? transaction.buyer.username : user.username}</h5>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>{transaction.type ? Helping.getTitleCase(transaction.type) : null}</td>
                                                                <td>{transaction.total_amount ? <MoneyField value={transaction.total_amount} /> : null}</td>
                                                                <td>{transaction.payment_type ? Helping.removeSpacialCharactersFromString(transaction.payment_type) : null}</td>
                                                                <td class={`status ${transaction.status === 'confirmed' ? "yes" : transaction.status === 'failed' ? 'no' : ''}`}>{transaction.status ? Helping.getTitleCase(transaction.status) : null}</td>
                                                                <td>{transaction.created_at ? Helping.convertTimeToHumanReadableFormat(transaction.created_at) : null}</td>
                                                                <td>
                                                                    <button class="icon view" title="View Detail" onClick={(e) => this.redirectToTransactionDetailPage(e, transaction)}>
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="17.5" height="13.5" viewBox="0 0 17.5 13.5">
                                                                            <g id="Show" transform="translate(0.75 0.75)">
                                                                                <path id="Stroke_1" data-name="Stroke 1" d="M5.469,2.6A2.669,2.669,0,0,1,2.734,5.2,2.668,2.668,0,0,1,0,2.6,2.668,2.668,0,0,1,2.734,0,2.669,2.669,0,0,1,5.469,2.6Z" transform="translate(5.266 3.402)" fill="none" stroke="#00EC93" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" />
                                                                                <path id="Stroke_3" data-name="Stroke 3" d="M8,12c3.293,0,6.306-2.25,8-6-1.7-3.75-4.708-6-8-6H8C4.708,0,1.7,2.25,0,6c1.7,3.75,4.708,6,8,6Z" fill="none" stroke="#00EC93" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" />
                                                                            </g>
                                                                        </svg>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div class="table-bottom">
                                                <div class="dataTables_length">
                                                    <label>Show
                                                        <select
                                                            name="userDataTable_length"
                                                            value={this.props.limit}
                                                            onChange={(e) => this.handleLimitChange(e.target.value)}
                                                        >
                                                            <option value="10">10</option>
                                                            <option value="25">25</option>
                                                            <option value="50">50</option>
                                                            <option value="100">100</option>
                                                        </select> of {this.props.total}</label>
                                                </div>
                                                <Pagination
                                                    // hideFirstLastPages
                                                    activePage={this.props.page}
                                                    itemsCountPerPage={this.props.limit}
                                                    totalItemsCount={this.props.total}
                                                    pageRangeDisplayed={5}
                                                    onChange={this.handlePageChange}
                                                    itemClass='page-item'
                                                    linkClass='page-link'
                                                    prevPageText='Pre'
                                                    nextPageText='Next'
                                                    firstPageText='First'
                                                    lastPageText='Last'
                                                    innerClass="dataTables_paginate"
                                                    linkClass="paginate_button"
                                                    activeLinkClass="paginate_button current"
                                                    disabledClass="paginate_button disabled"
                                                />
                                            </div>
                                        </>
                                    )}
                                    {(this.props.total < 1 && !this.props.isLoading) && (
                                        <div className='table-responsive'>
                                            <Notification
                                                type='danger'
                                                message={Helping.getMessageString(
                                                    NOT_FOUND,
                                                    'Transactions '
                                                )}
                                                callback={this.removeNetworkError}
                                            />
                                        </div>
                                    )}
                                </div>
                                <div class="tab-pane" id="walletHistory" role="tabpanel">
                                    {this.state.total > 0 && (
                                        <>
                                            <div class="listing-tbl table-responsive">
                                                <table class="table">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">ID</th>
                                                            <th scope="col" class="userFullName">Username</th>
                                                            <th scope="col">Total Amount</th>
                                                            <th scope="col">Type</th>
                                                            <th scope="col">Charge ID</th>
                                                            <th scope="col">Date Created</th>
                                                            <th scope="col"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.rows.map((row, i) => (
                                                            <tr key={i}>
                                                                <td scope="row">{row.id}</td>
                                                                <td>
                                                                    <div class="user-info">
                                                                        <div class="info">
                                                                            <h5 class="name">{this.getOwnerName(user.username)}</h5>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>{row.amount ? <MoneyField value={row.amount} /> : null}</td>
                                                                <td>{row.type ? Helping.getTitleCase(row.type) : null}</td>
                                                                <td>{row.charge_id ? row.charge_id : null}</td>
                                                                <td>{row.created_at ? Helping.convertTimeToHumanReadableFormat(row.created_at) : null}</td>
                                                                <td>
                                                                    {row.transaction &&
                                                                        <button class="icon view" title="View Detail" onClick={(e) => this.redirectToTransactionDetailPage(e, row.transaction)}>
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="17.5" height="13.5" viewBox="0 0 17.5 13.5">
                                                                                <g id="Show" transform="translate(0.75 0.75)">
                                                                                    <path id="Stroke_1" data-name="Stroke 1" d="M5.469,2.6A2.669,2.669,0,0,1,2.734,5.2,2.668,2.668,0,0,1,0,2.6,2.668,2.668,0,0,1,2.734,0,2.669,2.669,0,0,1,5.469,2.6Z" transform="translate(5.266 3.402)" fill="none" stroke="#00EC93" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" />
                                                                                    <path id="Stroke_3" data-name="Stroke 3" d="M8,12c3.293,0,6.306-2.25,8-6-1.7-3.75-4.708-6-8-6H8C4.708,0,1.7,2.25,0,6c1.7,3.75,4.708,6,8,6Z" fill="none" stroke="#00EC93" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" />
                                                                                </g>
                                                                            </svg>                                                                        </button>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div class="table-bottom">
                                                <div class="dataTables_length">
                                                    <label>Show
                                                        <select
                                                            name="userDataTable_length"
                                                            value={this.state.wallet_limit}
                                                            onChange={(e) => this.handleWalletLimitChange(e.target.value)}
                                                        >
                                                            <option value="10">10</option>
                                                            <option value="25">25</option>
                                                            <option value="50">50</option>
                                                            <option value="100">100</option>
                                                        </select> of {this.state.total}</label>
                                                </div>
                                                <Pagination
                                                    // hideFirstLastPages
                                                    activePage={this.state.wallet_activePage}
                                                    itemsCountPerPage={this.state.wallet_limit}
                                                    totalItemsCount={this.state.total}
                                                    pageRangeDisplayed={5}
                                                    onChange={this.handleWalletPageChange}
                                                    itemClass='page-item'
                                                    linkClass='page-link'
                                                    prevPageText='Pre'
                                                    nextPageText='Next'
                                                    firstPageText='First'
                                                    lastPageText='Last'
                                                    innerClass="dataTables_paginate"
                                                    linkClass="paginate_button"
                                                    activeLinkClass="paginate_button current"
                                                    disabledClass="paginate_button disabled"
                                                />
                                            </div>
                                        </>
                                    )}
                                    {(this.state.total < 1 && !this.state.isLoading) && (
                                        <div className='table-responsive'>
                                            <Notification
                                                type='danger'
                                                message={Helping.getMessageString(
                                                    NOT_FOUND,
                                                    'Wallet History '
                                                )}
                                                callback={this.removeNetworkError}
                                            />
                                        </div>
                                    )}
                                </div>
                                <div class="tab-pane" id="Inventory" role="tabpanel">
                                    {this.props.copies_total > 0 && (
                                        <>
                                            <div class="listing-tbl table-responsive">
                                                <table class="table">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">ID</th>
                                                            <th scope="col" class="userFullName">Owner</th>
                                                            <th scope="col">Item Name</th>
                                                            <th scope="col">Code</th>
                                                            <th scope="col">Amount</th>
                                                            <th scope="col">Item Order</th>
                                                            <th scope="col">View Count</th>
                                                            <th scope="col">On Sale</th>
                                                            <th scope="col">Sale Count</th>
                                                            <th scope="col">Blockchain</th>
                                                            <th scope="col"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.props.copies.map((copy, i) => (
                                                            <tr key={i}>
                                                                <td scope="row">{copy.id}</td>
                                                                <td>
                                                                    <div class="user-info">
                                                                        <div class="info">
                                                                            <h5 class="name">{copy.owner ? this.getOwnerName(copy.owner.username) : null}</h5>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className="truncate">{copy.item ? copy.item.name : ""}</td>
                                                                <td>{copy.code ? copy.code : null}</td>
                                                                <td>{copy.amount ? <MoneyField value={copy.amount} /> : 0}</td>
                                                                <td>{copy.item_order}</td>
                                                                <td>{copy.view_count}</td>
                                                                <td class={copy.enableSale ? 'yes' : ''}>{copy.enableSale ? 'Yes' : 'No'}</td>
                                                                <td>{copy.sale_count}</td>
                                                                <td>{copy.which_bc}</td>
                                                                <td>
                                                                    <div class="action-links">
                                                                        <a class="icon location" title='Blockchain Info' target="_blank"
                                                                            href={this.getMetaMaskLink(copy)}>
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-globe"><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>
                                                                        </a>
                                                                        <a href={STORE_WEBSITE + 'item/' + copy.code} class="icon view" title="View Item Detail">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="17.5" height="13.5" viewBox="0 0 17.5 13.5">
                                                                                <g id="Show" transform="translate(0.75 0.75)">
                                                                                    <path id="Stroke_1" data-name="Stroke 1" d="M5.469,2.6A2.669,2.669,0,0,1,2.734,5.2,2.668,2.668,0,0,1,0,2.6,2.668,2.668,0,0,1,2.734,0,2.669,2.669,0,0,1,5.469,2.6Z" transform="translate(5.266 3.402)" fill="none" stroke="#00EC93" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" />
                                                                                    <path id="Stroke_3" data-name="Stroke 3" d="M8,12c3.293,0,6.306-2.25,8-6-1.7-3.75-4.708-6-8-6H8C4.708,0,1.7,2.25,0,6c1.7,3.75,4.708,6,8,6Z" fill="none" stroke="#00EC93" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" />
                                                                                </g>
                                                                            </svg>
                                                                        </a>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div class="table-bottom">
                                                <div class="dataTables_length">
                                                    <label>Show
                                                        <select
                                                            name="userDataTable_length"
                                                            value={this.props.copies_limit}
                                                            onChange={(e) => this.handleInventoryLimitChange(e.target.value)}
                                                        >
                                                            <option value="10">10</option>
                                                            <option value="25">25</option>
                                                            <option value="50">50</option>
                                                            <option value="100">100</option>
                                                        </select> of {this.props.copies_total}</label>
                                                </div>
                                                <Pagination
                                                    // hideFirstLastPages
                                                    activePage={this.props.copies_page}
                                                    itemsCountPerPage={this.props.copies_limit}
                                                    totalItemsCount={this.props.copies_total}
                                                    pageRangeDisplayed={5}
                                                    onChange={this.handleInventoryPageChange}
                                                    itemClass='page-item'
                                                    linkClass='page-link'
                                                    prevPageText='Pre'
                                                    nextPageText='Next'
                                                    firstPageText='First'
                                                    lastPageText='Last'
                                                    innerClass="dataTables_paginate"
                                                    linkClass="paginate_button"
                                                    activeLinkClass="paginate_button current"
                                                    disabledClass="paginate_button disabled"
                                                />
                                            </div>
                                        </>
                                    )}
                                    {(this.props.copies_total < 1 && !this.props.copies_isLoading) && (
                                        <div className='table-responsive'>
                                            <Notification
                                                type='danger'
                                                message={Helping.getMessageString(
                                                    NOT_FOUND,
                                                    'Inventory Items '
                                                )}
                                                callback={this.removeNetworkError}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                )}
                {(!user && !this.state.isLoading) && (
                    <div className='table-responsive'>
                        <Notification
                            type='danger'
                            message={Helping.getMessageString(
                                NOT_FOUND,
                                'User '
                            )}
                            callback={this.removeNetworkError}
                        />
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    profile: state.profile,
    copies: state.itemCopies,
    transactions: state.transactions,
    isLoading: state.transactionsMeta.isLoading,
    page: state.transactionsMeta.page,
    limit: state.transactionsMeta.limit,
    count: state.transactionsMeta.length,
    total: state.transactionsMeta.total,
    no_Of_pages: state.transactionsMeta.no_Of_pages,
    copies_total: state.itemCopiesMeta.total,
    copies_page: state.itemCopiesMeta.page,
    copies_limit: state.itemCopiesMeta.limit,
    copies_no_Of_pages: state.itemCopiesMeta.no_Of_pages,
    copies_isLoading: state.itemCopiesMeta.isLoading
})

const mapDispatchToProps = {
    addCurrentRoute,
    getAll,
    getCopies,
    destroy,
    destroyCopies
}

export default connect(mapStateToProps, mapDispatchToProps)(Detail);